import {
    LuUsers,
    LuBuilding2,
    LuBriefcase,
    LuPieChart,
    LuLandmark,
    LuPuzzle,
    LuNetwork,
    LuHeartPulse,
    LuSend,
} from 'react-icons/lu';

// One list drives both the left menu and the home page tiles, so a new page
// only has to be added here to show up in both.
export const FEATURE_SECTIONS = [
    {
        title: 'Explore',
        features: [
            { path: '/people', label: 'People', Icon: LuUsers,
              description: 'Everyone we know, and how we know them' },
            { path: '/companies', label: 'Companies', Icon: LuBuilding2,
              description: 'Every company on our records, and whether it is monitored' },
            { path: '/deals', label: 'Deals', Icon: LuBriefcase,
              description: 'The deal pipeline, grouped by stage' },
            { path: '/portfolio', label: 'Portfolio', Icon: LuPieChart,
              description: 'Our investments, reconciled from calls and investor email' },
            { path: '/lp-commitments', label: 'LP Commitments', Icon: LuLandmark,
              description: 'Fund commitments that public pensions and endowments publish' },
            { path: '/lp-tool', label: 'Extension details', Icon: LuPuzzle,
              description: 'The LP outreach Chrome extension and the version it uses' },
            { path: '/ask-network', label: 'Ask the Network', Icon: LuNetwork,
              description: 'Ask in plain words who in our network can help' },
            { path: '/feature-health', label: 'Feature Health', Icon: LuHeartPulse,
              description: 'Whether each automated feature is still working' },
        ],
    },
    {
        title: 'Pipeline',
        features: [
            { path: '/outbound-engine', label: 'Outbound Engine', Icon: LuSend,
              description: 'Outbound deal sourcing' },
        ],
    },
];
